// We have to use direct import from the reducers (instead of using the Index file) to
// avoid circular dependencies with the action creators (who use these selectors)
import * as _notifSelectors from "./notification/reducer";

// Helper to wrap a redux selector with a predetermined state slice function
// https://gist.github.com/jslatts/1c5d4d46b6e5b0ac0e917fa3b6f7968f
const bindSelectors = (slicer, selectors) => {
  const keys = Object.keys(selectors);
  const boundMethods = {};

  keys.forEach((k) => {
    boundMethods[k] = (fullState) => selectors[k](slicer(fullState));
  });

  return boundMethods;
};


// ----------------- Selectors ------------------
// Partitioned according to state tree shape
export const notifSelectors = { ...bindSelectors((state) => state.notif, _notifSelectors) };
